import type { TPaymentMethod, TPaymentMethodCredential } from '../../store/types';

export const convertMethodsToTable = (items: TPaymentMethod[]): TPaymentMethod[] => {
  const sortedItems = [...items].sort((a, b) => b.id - a.id);
  const filteredItems = [...sortedItems.filter((item) => item.active), ...sortedItems.filter((item) => !item.active)];

  return filteredItems;
};

export const convertMethodsCredentials = (items: TPaymentMethodCredential[]): TPaymentMethodCredential[] => {
  const sortedItems = [...items].sort((a, b) => b.id - a.id);

  return sortedItems;
};
